<template>
  <div class="login__page">
    <div class="login__card">
      <div class="login__content">
        <TheLoginForm @success="returnToApp" />
      </div>
    </div>
  </div>
</template>

<script>
import Router from "vue-router";

import { hasAuthToken } from "@/utils/authToken";

import TheLoginForm from "@/views/components/login/TheLoginForm.vue";

export default {
  name: "LoginPage",
  components: { TheLoginForm },
  props: {
    returnTo: {
      type: Router.Route,
      default: null,
    },
  },
  watch: {
    $route(to) {
      if (to.name === "login" && hasAuthToken()) {
        this.returnToApp();
      }
    },
  },
  methods: {
    returnToApp() {
      if (this.returnTo) {
        this.$router.replace(this.returnTo);
      } else {
        this.$router.replace("/moje-zamowienia");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/scss/_breakpoints.scss";
@import "_login.scss";
</style>
